module.exports = __webpack_public_path__ + "img/TK.2b38d14b.png";